import React from 'react';
import reducer from './reducer/shop-list-ts/index.js';
import ShopListTSApplication from './container/shop-list-ts/application.jsx';
import createRootApplication from './root-application';

createRootApplication(<ShopListTSApplication />, reducer);



// WEBPACK FOOTER //
// ./src/shop-list-ts.jsx